import { Loader2 } from 'lucide-react'

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const spinnerSizes = {
  sm: 16,
  md: 24,
  lg: 32,
}

export function Spinner({ size = 'md', className = '' }: SpinnerProps) {
  return (
    <Loader2
      size={spinnerSizes[size]}
      className={`spinner ${className}`}
      aria-label="Cargando"
    />
  )
}

// Full page loading
export function PageLoader() {
  return (
    <div className="page-loader">
      <Spinner size="lg" />
    </div>
  )
}

// Skeleton components for content loading
interface SkeletonProps {
  className?: string
}

export function Skeleton({ className = '' }: SkeletonProps) {
  return <div className={`skeleton ${className}`} aria-hidden="true" />
}

export function SkeletonText({ lines = 3, className = '' }: { lines?: number; className?: string }) {
  return (
    <div className={`skeleton-text ${className}`} aria-hidden="true">
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className={`skeleton-line ${i === lines - 1 ? 'skeleton-line-short' : ''}`} />
      ))}
    </div>
  )
}

export function SkeletonCard({ className = '' }: SkeletonProps) {
  return (
    <div className={`skeleton-card ${className}`} aria-hidden="true">
      <Skeleton className="skeleton-avatar" />
      <div className="skeleton-content">
        <Skeleton className="skeleton-title" />
        <Skeleton className="skeleton-subtitle" />
      </div>
    </div>
  )
}

// List skeleton
export function SkeletonList({ count = 3, className = '' }: { count?: number; className?: string }) {
  return (
    <div className={`skeleton-list ${className}`} aria-label="Cargando contenido">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  )
}

// Inline loading text
export function LoadingText({ text = 'Cargando...' }: { text?: string }) {
  return (
    <span className="loading-text">
      <Spinner size="sm" />
      <span>{text}</span>
    </span>
  )
}
